module.exports = __webpack_public_path__ + "img/etiquetes-adhesives.1f3f2483.jpg";